// A clean, reusable loading spinner — replaces plain "Loading..." text
// across every screen that fetches data. Uses a CSS animation (no extra
// library needed) for a smooth spinning circle, similar to Gmail's style.
function LoadingSpinner({ size = 32, fullScreen = false }) {
  const spinner = (
    <div
      style={{
        width: size,
        height: size,
        border: '3px solid #e5e7eb',
        borderTopColor: '#2563eb',
        borderRadius: '50%',
        animation: 'spin 0.7s linear infinite',
      }}
    />
  );

  if (fullScreen) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
        }}
      >
        {spinner}
      </div>
    );
  }

  return spinner;
}

export default LoadingSpinner;